<script setup>
const props = defineProps({
    videoEmbedCode: {
        type: String,
        required: true,
    },
    anchorId: {
        type: String,
    }
});

const videoUrl = ref('');

function parseEmbedCode(embedCode) {
    const match = embedCode.match(/(?<=src=").+?"/);
    let url = match?.[0]?.replace(/"$/, '') || undefined;
    if (url && url.includes('youtube.com')) {
        const separator = url.includes('?') ? '&' : '?';
        url = `${url}${separator}rel=0`;
    }
    videoUrl.value = url || undefined;
}

onMounted(() => {
    parseEmbedCode(props.videoEmbedCode);
});
</script>

<template>
    <section class="block block-blog-video container" :id="anchorId || null" tabindex="-1">
        <div class="w-full aspect-video">
            <iframe class="w-full h-full rounded-(--radius)" loading="lazy" :src="videoUrl"
                sandbox="allow-presentation allow-same-origin allow-scripts"></iframe>
        </div>
    </section>
</template>
